const riot = require('riot');

riot.tag2('popup-reactions', '<div class="w280 bg-white rounded-8 box-shadow-primary px14 py12" ref="popup" onmouseleave="{close}"> <div class="f flex-wrap"> <div class="f fh s24 rounded-4 fs19 hover-trigger hover-bg-background_light_primary cursor-pointer mx2 my4" each="{reaction in opts.reactions._map}" onclick="{select}"> <div title="{reaction.name}">{reaction.value}</div> </div> </div> </div>', '', '', function(opts) {
    this.select = (e) => {
      let item = e.item.reaction;
      this.trigger('selected', item);
    };
});